function dateFormat(dateString) {
    if (!dateString) {
        return null;
    }

    const stringValue = String(dateString); // Converte para string

    let date;

    if (stringValue.includes('T')) {
        date = new Date(stringValue);
    } else if (stringValue.includes('-')) {
        const [year, month, day] = stringValue.split('-').map(Number);
        date = new Date(year, month - 1, day);
    } else {
        date = new Date(Number(stringValue));
    }

    if (isNaN(date.getTime())) {
        return null;
    }

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedDay}/${formattedMonth}/${year}`;
}

function isValidDate(dateString) {
    const date = new Date(dateString);
    
    if (date.toString() === 'Invalid Date') {
        return false;
    }
    
    const timestamp = Date.parse(dateString);
    if (isNaN(timestamp)) {
        return false;
    }
    
    return true;
}

export default { dateFormat, isValidDate };
